/** Strings of `/projects` (listing) and `/projects/new`. */
export const projNewEn = {
  projList: {
    title: "Projects",
    total_one: "{{count}} project total",
    total_other: "{{count}} projects total",
    total_few: "{{count}} projects total",
    add: "Add Project",
    search: "Search projects or groups...",
    empty: "No projects yet.",
    ungrouped: "Ungrouped",
    groupCount_one: "{{count}} project",
    groupCount_other: "{{count}} projects",
    groupCount_few: "{{count}} projects",
    viewAria: "Projects view",
    pillView: "Pill view",
    tableView: "Table view",
    colProject: "Project",
    colGroup: "Group",
    colCustomer: "Customer",
    colRole: "Role",
    colOpen: "Open",
    colTracked: "Tracked 7d",
    colLastActivity: "Last activity",
    youManage: "You manage this project",
    notMember: "Not a member",
    priority: {
      urgent: "Urgent",
      high: "High",
      normal: "Normal",
      low: "Low",
    },
    openTasks: "open tasks",
    tracked7d: "tracked · last 7 days",
  },
  projNew: {
    created: "Project created",
    error: "Error",
    createFailed: "Couldn't create project",
    title: "New project",
    intro:
      "Import a GitLab repository into Hub or start a new one. Issues, members and milestones sync over on the next periodic GitLab tick; Vault collections are created right after.",
    creatorTitle: "Plan it with the creator",
    creatorDesc:
      "In lair on your machine: describe the project, hand over the materials, plan it together. The creator then creates the project, its repo, wiki, releases and first tickets.",
    openInLair: "Open in lair",
    lairHelp:
      "Nothing opened? Install lair (<install>{{command}}</install>) or run <run>lair creator</run>.",
    detailsTitle: "Details",
    detailsDesc:
      "Pick the repo and the customer it belongs to. Anything that doesn't exist yet can be created here.",
    customer: "Customer",
    pickCustomer: "— pick customer —",
    newCustomer: "+ New customer",
    newCustomerName: "New customer name",
    customerName: "Customer name",
    repository: "GitLab repository",
    existingRepo: "Existing repo",
    newRepo: "New repo",
    allImported: "All GitLab repos are imported",
    searchRepos: "Search GitLab repos…",
    noMatchingRepos: "No matching repos",
    onlyUnimported: "Only repos Hub hasn't imported yet show up here.",
    group: "GitLab group",
    pickGroup: "Pick a group…",
    noMatchingGroups: "No matching groups",
    newGroup: "+ New group",
    repoPath: "Repository path",
    repoPathPlaceholder: "repo-path",
    newGroupName: "New group name",
    groupNamePlaceholder: "Group name, usually the customer",
    repoNote:
      "A private repo with a README on <code>main</code>. The group follows the customer until you pick one.",
    repoNotePath:
      "A private repo with a README on <code>main</code> at <code>{{path}}</code>. The group follows the customer until you pick one.",
    repoNoteGroup:
      "A new private group and a private repo with a README on <code>main</code>. The group follows the customer until you pick one.",
    repoNoteGroupPath:
      "A new private group and a private repo with a README on <code>main</code> at <code>{{path}}</code>. The group follows the customer until you pick one.",
    mirroredFrom: "Mirrored from",
    mirroredHint:
      "Optional — the upstream this GitLab repo is a push mirror of. Time tracked in a checkout of it is proposed here.",
    label: "Label",
    displayName: "Display name",
    namePlaceholder: "My project",
    seafileFolder: "Create a Seafile folder",
    seafileOn:
      "In the Projekty library, named after the project. An existing folder of that name is bound instead.",
    seafileOff:
      "Seafile isn't managed by Hub here; bind a folder later in the project's Settings → Access.",
    creating: "Creating",
    create: "Create project",
    cancel: "Cancel",
  },
};

export const projNewCs: typeof projNewEn = {
  projList: {
    title: "Projekty",
    total_one: "{{count}} projekt celkem",
    total_other: "projektů celkem: {{count}}",
    total_few: "{{count}} projekty celkem",
    add: "Přidat projekt",
    search: "Hledat projekty nebo skupiny...",
    empty: "Zatím žádné projekty.",
    ungrouped: "Bez skupiny",
    groupCount_one: "{{count}} projekt",
    groupCount_other: "projektů: {{count}}",
    groupCount_few: "{{count}} projekty",
    viewAria: "Zobrazení projektů",
    pillView: "Zobrazení karet",
    tableView: "Zobrazení tabulky",
    colProject: "Projekt",
    colGroup: "Skupina",
    colCustomer: "Zákazník",
    colRole: "Role",
    colOpen: "Otevřené",
    colTracked: "Odpracováno 7 dní",
    colLastActivity: "Poslední aktivita",
    youManage: "Tento projekt spravujete",
    notMember: "Nejste členem",
    priority: {
      urgent: "Naléhavá",
      high: "Vysoká",
      normal: "Normální",
      low: "Nízká",
    },
    openTasks: "otevřených úkolů",
    tracked7d: "odpracováno · posledních 7 dní",
  },
  projNew: {
    created: "Projekt vytvořen",
    error: "Chyba",
    createFailed: "Projekt se nepodařilo vytvořit",
    title: "Nový projekt",
    intro:
      "Naimportujte do Hubu repozitář z GitLabu, nebo založte nový. Tikety, členové a milníky se přenesou při příštím pravidelném průchodu GitLabu; kolekce ve Vaultu se vytvoří hned poté.",
    creatorTitle: "Naplánujte ho s tvůrcem",
    creatorDesc:
      "V lairu na vašem počítači: popište projekt, předejte podklady a naplánujte ho společně. Tvůrce pak vytvoří projekt, jeho repozitář, wiki, vydání a první tikety.",
    openInLair: "Otevřít v lairu",
    lairHelp:
      "Nic se neotevřelo? Nainstalujte lair (<install>{{command}}</install>) nebo spusťte <run>lair creator</run>.",
    detailsTitle: "Podrobnosti",
    detailsDesc:
      "Vyberte repozitář a zákazníka, kterému patří. Cokoli, co ještě neexistuje, můžete vytvořit rovnou tady.",
    customer: "Zákazník",
    pickCustomer: "— vyberte zákazníka —",
    newCustomer: "+ Nový zákazník",
    newCustomerName: "Jméno nového zákazníka",
    customerName: "Jméno zákazníka",
    repository: "Repozitář v GitLabu",
    existingRepo: "Existující repozitář",
    newRepo: "Nový repozitář",
    allImported: "Všechny repozitáře z GitLabu jsou naimportované",
    searchRepos: "Hledat repozitáře v GitLabu…",
    noMatchingRepos: "Žádný odpovídající repozitář",
    onlyUnimported: "Zobrazují se jen repozitáře, které Hub ještě neimportoval.",
    group: "Skupina v GitLabu",
    pickGroup: "Vyberte skupinu…",
    noMatchingGroups: "Žádná odpovídající skupina",
    newGroup: "+ Nová skupina",
    repoPath: "Cesta repozitáře",
    repoPathPlaceholder: "cesta-repozitare",
    newGroupName: "Název nové skupiny",
    groupNamePlaceholder: "Název skupiny, obvykle zákazník",
    repoNote:
      "Soukromý repozitář s README ve větvi <code>main</code>. Skupina se řídí zákazníkem, dokud nějakou nevyberete.",
    repoNotePath:
      "Soukromý repozitář s README ve větvi <code>main</code> na adrese <code>{{path}}</code>. Skupina se řídí zákazníkem, dokud nějakou nevyberete.",
    repoNoteGroup:
      "Nová soukromá skupina a v ní soukromý repozitář s README ve větvi <code>main</code>. Skupina se řídí zákazníkem, dokud nějakou nevyberete.",
    repoNoteGroupPath:
      "Nová soukromá skupina a v ní soukromý repozitář s README ve větvi <code>main</code> na adrese <code>{{path}}</code>. Skupina se řídí zákazníkem, dokud nějakou nevyberete.",
    mirroredFrom: "Zrcadleno z",
    mirroredHint:
      "Volitelné — upstream, jehož push mirrorem je tento repozitář v GitLabu. Čas zaznamenaný v jeho checkoutu se navrhne sem.",
    label: "Popisek",
    displayName: "Zobrazovaný název",
    namePlaceholder: "Můj projekt",
    seafileFolder: "Vytvořit složku v Seafile",
    seafileOn:
      "V knihovně Projekty, pojmenovanou podle projektu. Existující složka se stejným názvem se připojí místo toho.",
    seafileOff:
      "Seafile tady Hub nespravuje; složku připojíte později v Nastavení projektu → Přístup.",
    creating: "Vytváření",
    create: "Vytvořit projekt",
    cancel: "Zrušit",
  },
};
